import { useCallback, useMemo, useState } from 'react';
import { logError } from '@betty/toolkit/logging';
import { useSelector } from '@betty/toolkit/state';
import { DepositPromo } from '../state/deposit/deposit.types';
import { selectDepositCount } from '../state/depositCount/depositCount.slice';
import { parseDepositPromos } from '../components/Deposit/Deposit.utils';
import PromosService from '../services/PromosService/PromosService';

const useDepositPromos = () => {
  const [data, setData] = useState<DepositPromo[]>();
  const depositCount = useSelector(selectDepositCount);

  const fetch = useCallback(async () => {
    try {
      setData(undefined);

      const { items } = await PromosService.getPromos();

      setData(items);

      return items;
    } catch (error) {
      logError('Deposit promotions request failure.', error);

      return [];
    }
  }, []);

  return {
    data: useMemo(
      () => parseDepositPromos(data, depositCount),
      [data, depositCount],
    ),
    fetch,
  };
};

export default useDepositPromos;
